export const CURRENCY_SYMBOLS = {
  gbp: '£',
  usd: '$'
};
